import { render } from "./FinanceiroCategoriasTab.vue?vue&type=template&id=8cc42ca2&scoped=true"
import script from "./FinanceiroCategoriasTab.vue?vue&type=script&lang=js"
export * from "./FinanceiroCategoriasTab.vue?vue&type=script&lang=js"

import "./FinanceiroCategoriasTab.vue?vue&type=style&index=0&id=8cc42ca2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cc42ca2"]])

export default __exports__